import React from 'react';

// Extracted from LessonWorkspace.js (Phase 3 of the platform-health plan:
// split the file mechanically, without changing behavior).
export default function SaveChangesModal({
  show,
  isStudent,
  addSnapshotToLibrary,
  onAddSnapshotToLibraryChange,
  onCancel,
  onDontSave,
  onSaveAndContinue,
}) {
  if (!show) return null;

  return (
    <div className="custom-modal-overlay">
      <div className="custom-modal">
        <div className="custom-modal-header">
          <h3>Save Changes?</h3>
          <button className="custom-modal-close" onClick={onCancel}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
        <div className="custom-modal-body">
          <p>Do you want to save the changes?</p>
          {!isStudent && (
            <div style={{ marginTop: 8 }}>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <input
                  type="checkbox"
                  checked={addSnapshotToLibrary}
                  onChange={(e) => onAddSnapshotToLibraryChange(e.target.checked)}
                />
                <span style={{ fontSize: 12, color: '#374151' }}>Add standalone copy to Lesson Library (not linked to student)</span>
              </label>
              <div style={{ fontSize: 11, color: '#6b7280', marginLeft: 26, marginTop: 6, lineHeight: 1.35 }}>
                This copy will not receive future changes made in the student's lesson. The teacher can reuse it for other students or publish it later.
              </div>
            </div>
          )}
        </div>
        <div className="custom-modal-footer">
          <button className="custom-modal-btn cancel-btn" onClick={onDontSave}>
            Don't Save
          </button>
          <button className="custom-modal-btn confirm-btn" onClick={onSaveAndContinue}>
            Save & Continue
          </button>
        </div>
      </div>
    </div>
  );
}
